<template>
  <div id="app">
    <component :is="curView" v-if="loaded"></component>
    <div v-if="!loaded" class="center vertical-middle loading">
      Loading ...
    </div>
  </div>
</template>

<script>
import AppMain from '@/layout'
export default {
  name: 'app',
  data () {
    return {
      curView: null,
      is_success: true
    }
  },
  components: {
    ...AppMain
  },
  watch: {
    $route () {
      // 匹配视图
      let tp = this.$router.currentRoute.meta.view
      if (tp in AppMain) {
        this.curView = tp || null
        console.warn(`curView: ${tp}`)
      } else {
        console.error(
          `layout view ${tp} is unavailable ,make sure ${tp}.vue existed in src/layout and configured in src/layout/index.js`
        )
      }
    },
    '$auth.watch.authenticated': {
      handler: function (val) {
        if (val) {
          this.getMenu()
        }
      },
      immediate: true
    },
    '$store.state.menuList': {
      handler: function (val) {
        if (val && val.length === 1) {
          // 页面进入的时候，如果只有一个主菜单，就跳到其第一个子菜单
          if (!this.$route.path || this.$route.path === '/') {
            let path = val[0].children && val[0].children[0].action
            this.$router.push(path)
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    menuHasLoaded () {
      return this.$store.state.menuList > 0
    },
    mobile () {
      return this.$auth.user() && this.$auth.user().mobile
    },
    loaded () {
      return (
        this.$auth.ready() &&
          (this.menuHasLoaded ||
            !this.$auth.watch.authenticated ||
            this.is_success)
      )
    }
  },
  methods: {
    getMenu () {
      this.$store.dispatch('getMenu').then(res => {
        if (res.length === 0) {
          this.is_success = true
        }
      }).catch(err => {
        this.$message.error(err || '获取菜单失败')
      })
    }
  }
}

</script>

<style lang="less">
  html,
  body {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    font-size: 14px;
  }

  li {
    list-style-type: none;
  }

  #app {
    font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000;
    height: 100%;

    .page-factor-filter-top {
      label {
        color: #73777E
      }
    }

    .loading {
      color: #777;
      margin-top: -20%;
    }
  }

</style>
